import {
  FilteredTrainerPayload,
  PaginatedTrainersDTO,
  TrainerResponseDTO
} from '@/store/modules/jtms/trainer/trainer.types';
import { axios } from './axios';
export const trainerApi = {
  getTrainers() {
    return axios.get<TrainerResponseDTO>('/trainer-accreditation/all');
  },
  getPaginatedTrainers(params: FilteredTrainerPayload) {
    return axios.get<PaginatedTrainersDTO>('/trainer-accreditation', {
      params: {
        ...params
      }
    });
  }
};
